











import Vue from 'vue'
import Component from 'vue-class-component'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'

const vueCustomScrollbar = require('vue-custom-scrollbar')

@Component({
  components: {
    vueCustomScrollbar
  },
  props: {
    settings: {
      type: Object,
      default: () => ({
        wheelPropagation: true
      })
    },
    stickyScrollbar: {
      type: Boolean,
      default: false
    }
  }
})
export default class ScrollView extends Vue {
  rail: any = null
  timeout: boolean = true
  observer: any = null

  mounted () {
    if (!this.$props.stickyScrollbar) {
      return
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.onScroll, { passive: true })
      /* eslint-disable */
      // @ts-ignore
      this.observer = new window.IntersectionObserver(([entry]: any) => {
        /* eslint-enable */
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.onScroll, { passive: true })
          this.onScroll()
          return
        }

        window.removeEventListener('scroll', this.onScroll)
      }, {
        root: null,
        threshold: 0
      })

      this.observer.observe(this.$el)
    })
  }

  updated () {
    if (this.$props.stickyScrollbar) {
      this.onScroll()
    }
  }

  beforeDestroy () {
    if (this.$props.stickyScrollbar) {
      window.removeEventListener('scroll', this.onScroll)
      window.removeEventListener('resize', this.onScroll)
      if (this.observer) {
        this.observer.disconnect()
      }
      this.observer = null
    }
  }

  onScroll () {
    const rails = this.$el.querySelectorAll('.ps__rail-x')
    this.rail = rails[rails.length - 1]
    const less = this.$el.getBoundingClientRect().top < window.innerHeight - 100
    const more = this.$el.getBoundingClientRect().bottom > window.innerHeight

    this.rail.style.top = less && more
      ? `calc(${-this.$el.getBoundingClientRect().top + (window.innerHeight - 20)}px)`
      : 'unset'
    this.rail.classList.add('hide')

    if (this.timeout) {
      this.timeout = false
      setTimeout(() => {
        this.timeout = true
        this.rail.classList.remove('hide')
      }, 500)
    }
  }
}
